import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';

import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from './core/config.service';

import { Session } from './core/session/session';
import { SessionService } from './core/session/session.service';
import { CCOrganization } from './model/organization/cc-org';
import { NAV_LEVEL, NavigationService } from './navigation/navigation.service';
import { AboutData, AboutDialogComponent } from './ui-shared/dialog/about-dialog.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly sessionService = inject(SessionService);
  private readonly dialog = inject(MatDialog);
  private readonly configService = inject(ConfigService);
  private readonly navigationService = inject(NavigationService);

  isHandset: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.Handset);
  @ViewChild('drawer') drawer?: MatSidenav;

  session?: Session;
  level?: Observable<NAV_LEVEL>;
  organization?: CCOrganization;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  private readonly subscriptions = new Subscription();


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
    this.navigationService.setTitle(this.configService.getTitle());
    this.level = this.navigationService.getLevel();

    this.subscriptions.add(this.sessionService.session$.subscribe(session => {
      console.log('Update session');
      this.session = session;
    }));

    this.navigationService.getOrganization().subscribe(org => {
      this.organization = org;
    });
  }

  ngAfterViewInit() {
    const element = document.getElementById('loading');
    if (element) {
      element.remove();
    }
  }

  logout() {
    console.log('Log out');
    this.sessionService.logout();
  }


  reload() {
    window.location.reload();
  }

  showAbout() {
    const aboutData: AboutData = {
      appIcon: 'app:deviceAdministrationApp',
      appName: this.configService.getTitle(),
      copyright: 'Copyright Heidelberger Druckmaschinen AG 2023',
      text: '',
    };

    this.dialog.open(AboutDialogComponent, {
      disableClose: true,
      data: aboutData,
      maxHeight: '90vh'
    });
  }
}
